import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import IGenericButtons from '../IGenericButtons';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import Tooltip from 'src/components/common/Tooltip/Tooltip';
import * as _ from 'lodash';

interface IGenericDownloadButtonProps extends IGenericButtons {
    onDownload?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export const GenericDownloadButton: React.FC<IGenericDownloadButtonProps> = ({
    trade,
    onDownload,
    setLoading: loading,
    tooltipTitle,
    disabled,
    onClick,
    children
}) => {
    const setLoading = (isLoading: boolean) => _.isFunction(loading) ? loading(isLoading) : null;

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        try {
            setLoading(true);
            if (_.isFunction(onDownload)) {
                onDownload(event)
            }

            if (_.isFunction(onClick)) {
                onClick(event);
            }
            setLoading(false);
        } catch (error) {
            ShowNotification.Error("Falha na consulta", "Ocorreu um erro ao baixar arquivo. Tente novamente.");
            setLoading(false);
        }
    }

    const handleDisabled = () => _.isFunction(disabled) ? disabled(trade) : _.isBoolean(disabled) ? disabled : false

    return (
        <Tooltip text={tooltipTitle ? tooltipTitle : "Download de documento"}>
            <button
                className="downlaod-generic btn"
                disabled={handleDisabled()}
                onClick={handleClick}
            >
                <FontAwesomeIcon icon={faCloudDownloadAlt} />
                {children}
            </button>
        </Tooltip>
    );
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/DownloadButtons/GenericDownloadButton.tsx